export default __webpack_public_path__ + "images/7e88313e2ae25250ec9ddb8520932fa3-holiday.jpg";